export default __webpack_public_path__ + "static/media/bgMaintenanceMobile.bda7b141.png";